import { User, OrganisationDto } from '@treetop/shared/model';

import { ChapterShare, GuidelineShare, OrganisationConnection, Share } from '../model/cluster.model';

export const getOrganisationToDisplayFromConnection = (
  connection: OrganisationConnection,
  currentUser: User | undefined,
): OrganisationDto | undefined => {
  if (!currentUser) return undefined;

  return connection.fromOrganisationId === currentUser.currentOrganisation.id ? connection.toOrganisation : connection.fromOrganisation;
};

export const isChapterShare = (share: Share): share is ChapterShare => {
  return 'allChapters' in share && 'selectedChapters' in share;
};

export const isGuidelineShare = (share: Share): share is GuidelineShare => {
  return 'selectedGuidelines' in share;
};
